import { render, staticRenderFns } from "./PaymentTable.vue?vue&type=template&id=67a7997b&scoped=true"
import script from "./PaymentTable.vue?vue&type=script&lang=js"
export * from "./PaymentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7997b",
  null
  
)

export default component.exports